// Daily Traffic Dashboards Default

// const api_host = "http://localhost:8000"
const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"

export const barChartDataDailyTraffic = [
  {
    name: "Daily Traffic",
    data: [20, 30, 40, 20, 45, 50, 30],
  },
];

export const barChartOptionsDailyTraffic = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    style: {
      fontSize: "12px",
      fontFamily: undefined,
    },
    onDatasetHover: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
    },
    theme: "dark",
  },
  xaxis: {
    categories: ["00", "04", "08", "12", "14", "16", "18"],
    show: false,
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
    color: "black",
    labels: {
      show: true,
      style: {
        colors: "#CBD5E0",
        fontSize: "14px",
      },
    },
  },
  grid: {
    show: false,
    strokeDashArray: 5,
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        [
          {
            offset: 0,
            color: "#4318FF",
            opacity: 1,
          },
          {
            offset: 100,
            color: "rgba(67, 24, 255, 1)",
            opacity: 0.28,
          },
        ],
      ],
    },
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      columnWidth: "40px",
    },
  },
};

export async function fetchTopGlycansBarChartData(){
  try {

    const api_path = `/api/get-top-glycans-data/`;
    const full_api_path = `${api_host}${api_path}`
    const response = await fetch(full_api_path);
    const data = await response.json();

    return data;

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}


// export const topGlycansBarChartData = [
//   {
//     name: "I",
//     data: [4.0, 48.0, 10.0, 0.0, 7.0, 37.0, 46.0, 2.0, 23.0, 72.0]
//   },
//   {
//     name: "II",
//     data: [77.0, 12.0, 39.0, 0.0, 27.0, 44.0, 17.0, 0.0, 60.0, 8.0]
//   }, {
//     name: "III",
//     data: [34.0, 31.0, 40.0, 0.0, 30.0, 21.0, 13.0, 63.0, 42.0, 13.0]
//   },
//   {
//     name: "IV",
//     data: [0.0, 12.0, 8.0, 99.0, 46.0, 1.0, 0.0, 15.0, 9.0, 3.0]
//   },
//   {
//     name: "NA",
//     data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 3.0, 0.0, 0.0]
//   }
// ];



// Consumption Users Reports

export const barChartDataConsumption = [

  {
    name: "I",
    data: [4.0, 48.0, 10.0, 0.0, 7.0, 37.0, 46.0, 2.0, 23.0, 72.0]
  },
  {
    name: "II",
    data: [77.0, 12.0, 39.0, 0.0, 27.0, 44.0, 17.0, 0.0, 60.0, 8.0]
  }, {
    name: "III",
    data: [34.0, 31.0, 40.0, 0.0, 30.0, 21.0, 13.0, 63.0, 42.0, 13.0]
  },
  {
    name: "IV",
    data: [0.0, 12.0, 8.0, 99.0, 46.0, 1.0, 0.0, 15.0, 9.0, 3.0]
  },
  {
    name: "NA",
    data: [0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 3.0, 0.0, 0.0]
  }
];

export const topGlycansBarChartOptions = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    style: {
      fontSize: "12px",
      fontFamily: undefined,
    },
    onDatasetHover: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
    },
    theme: "dark",
  },
  xaxis: {
    categories: ["BRC", "CCRCC", "CRC", "GBM", "HNSCC", "LSCC", "LUAD", "OVC", "PDAC", "UCEC"],
    show: false,
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: true,
    axisBorder: {
      show: true,  // Show the y-axis line
    },
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
      formatter: (value) => {
        return `${Math.round(value * 100)}%`;  // Format the label as a rounded percentage
      },
    },
  },

  grid: {
    borderColor: "rgba(163, 174, 208, 0.3)",
    show: true,
    yaxis: {
      lines: {
        show: false,
        opacity: 0.5,
      },
    },
    row: {
      opacity: 0.5,
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "solid",
      
      colors: ["#1F78B4", "#A6CEE3", "#E31A1C", "#FB9A99", "#33A02C", "#B2DF8A", "#6A3D9A", "#CAB2D6", "#8F7548", "#FF7F00"],
  },
  legend: {
    show: false,
  },
  colors: ["#1F78B4", "#A6CEE3", "#E31A1C", "#FB9A99", "#33A02C", "#B2DF8A", "#6A3D9A", "#CAB2D6", "#8F7548", "#FF7F00"],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      columnWidth: "20px",
    },
  },
};


export const barChartOptionsConsumption = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    style: {
      fontSize: "12px",
      fontFamily: undefined,
    },
    onDatasetHover: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
    },
    theme: "dark",
  },
  xaxis: {
    categories: ["BRC", "CCRCC", "CRC", "GBM", "HNSCC", "LSCC", "LUAD", "OVC", "PDAC", "UCEC"],
    show: false,
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
    color: "black",
    labels: {
      show: false,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
  },

  grid: {
    borderColor: "rgba(163, 174, 208, 0.3)",
    show: true,
    yaxis: {
      lines: {
        show: false,
        opacity: 0.5,
      },
    },
    row: {
      opacity: 0.5,
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "solid",
    colors: ["#F5F5F5", "#99CCFF", "#0047AB", "#003366", "#001F3F"],
  },
  legend: {
    show: false,
  },
  colors: ["#F5F5F5", "#99CCFF", "#0047AB", "#003366", "#001F3F"],
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      columnWidth: "20px",
    },
  },
};

export const gpIDsLineBarChartOptions = {
  
    chart: {
      id: 'basic-bar',
      toolbar: {
          show: false  // This line will hide the toolbar
        }
    },
    xaxis: {
      // categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
      categories: ['BRC','CCRCC','CRC','GBM','HNSCC','LSCC','LUAD','OVC','PDAC','UCEC']
    }

}

export const pieChartOptions = {
  labels: ["HM", "only_S", "S+F","only_F","Other"],
  colors: ["#008000", "#800080", "#FFA500", "#FF0000", "#D3D3D3"],
  // chart: {
  //   width: "50px",
  // },
  states: {
    hover: {
      filter: {
        type: "none",
      },
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  hover: { mode: null },
  plotOptions: {
    donut: {
      expandOnClick: false,
      donut: {
        labels: {
          show: false,
        },
      },
    },
  },
  fill: {
    colors: ["#008000", "#800080", "#FFA500", "#FF0000", "#D3D3D3"],
  },
  tooltip: {
    enabled: true,
    theme: "dark",
  },
};

// export const pieChartData = [63, 25, 12];

export async function fetchGPIDsLineBarChartData(){
  try {

    const api_path = `/api/get-gp-ids-data/`;
    const full_api_path = `${api_host}${api_path}`
    const response = await fetch(full_api_path);
    const data = await response.json();
  

    return data;

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}


// Create an async function to fetch data
export async function fetchData(project) {
  try {

    const api_path = `/api/get-nglycan-types-data/?project=${project}`;
    const full_api_path = `${api_host}${api_path}`
    const response = await fetch(full_api_path);
    const data = await response.json();

    // Assume the API returns an array of numbers for the pie chart data
    let pieChartData2 = data.data;

    return pieChartData2

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}


// Call the function to fetch data
// fetchData();

// Total Spent Default

export const lineChartDataTotalSpent = [
  {
    name: "Revenue",
    data: [50, 64, 48, 66, 49, 68],
  },
  {
    name: "Profit",
    data: [30, 40, 24, 46, 20, 46],
  },
];

export const lineChartOptionsTotalSpent = {
  chart: {
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 13,
      left: 0,
      blur: 10,
      opacity: 0.1,
      color: "#4318FF",
    },
  },
  legend: {
    show: true,
    position: 'bottom',
    horizontalAlign: 'center',
  },
  colors: ["#4318FF", "#39B8FF"],
  markers: {
    size: 0,
    colors: "white",
    strokeColors: "#7551FF",
    strokeWidth: 3,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    discrete: [],
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  tooltip: {
    theme: "dark",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    type: "line",
  },
  xaxis: {
    type: "numeric",
    categories: ["SEP", "OCT", "NOV", "DEC", "JAN", "FEB"],
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "12px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  // legend: {
  //   show: false,
  // },
  grid: {
    show: false,
    column: {
      color: ["#7551FF", "#39B8FF"],
      opacity: 0.5,
    },
  },
  color: ["#7551FF", "#39B8FF"],
};
